import { render, staticRenderFns } from "./StorageWarningBanner.vue?vue&type=template&id=0bcabfa7&scoped=true"
import script from "./StorageWarningBanner.vue?vue&type=script&lang=js"
export * from "./StorageWarningBanner.vue?vue&type=script&lang=js"
import style0 from "./StorageWarningBanner.vue?vue&type=style&index=0&id=0bcabfa7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcabfa7",
  null
  
)

export default component.exports